import './SEOSteps.css'

const steps = [
  {
    n: '1',
    title: 'WhatsApp-Export erstellen',
    desc: 'Chat öffnen → Mehr (⋮) → Chat exportieren → „Mit Medien" → ZIP speichern',
  },
  {
    n: '2',
    title: 'Datei hochladen & anpassen',
    desc: 'ZIP auf ChatArchiv.de hochladen. Stil, Farben und Filter in der Live-Vorschau einstellen.',
  },
  {
    n: '3',
    title: 'PDF herunterladen',
    desc: 'Vollständiges PDF mit Fotos, Emojis und Original-Layout — für immer gespeichert.',
  },
]

interface Props { onStart?: () => void }

export function SEOSteps({ onStart }: Props) {
  return (
    <section className="seo-steps">
      <div className="seo-steps-inner">
        <h2 className="seo-steps-title">In 3 Schritten zum PDF</h2>
        <div className="seo-steps-grid">
          {steps.map((s) => (
            <div key={s.n} className="seo-step-card">
              <div className="seo-step-num">{s.n}</div>
              <h3 className="seo-step-title">{s.title}</h3>
              <p className="seo-step-desc">{s.desc}</p>
            </div>
          ))}
        </div>
        {onStart && (
          <div className="seo-steps-cta">
            <button className="seo-btn-primary" onClick={onStart}>
              Kostenlos testen →
            </button>
          </div>
        )}
      </div>
    </section>
  )
}
